import { createSelector } from 'reselect';
import { GlobalState } from 'store/types';
import { KEY } from './';

const getSettingsState = (state: GlobalState) => state[KEY];

const selectConfigurationId = createSelector(getSettingsState, (settings) => settings.configurationId);

const selectSalesByKiosk = createSelector(getSettingsState, (state) => state.salesByKiosk);

const selectAction = createSelector(getSettingsState, (state) => state.action);

export const selectors = {
  selectConfigurationId,
  selectSalesByKiosk,
  selectAction
};
